<app-fn-ui-navigation-actions-tree class="liquidity-favorites-navigation"
                                   [treeConfig]="liquidityFavoritesService.treeConfig"
                                   [treeModel]="liquidityFavoritesService.tree.nodes"
                                   [selectedNode]="liquidityFavoritesService.activeNode"
                                   [nodeActions]="liquidityFavoriteNodeActionsService.nodeActions"
                                   [leafActions]="liquidityFavoriteNodeActionsService.nodeActions"
                                   (nodeActionClicked)="onMenuItemClick($event)">
</app-fn-ui-navigation-actions-tree>
